import classNames from 'classnames';
import React from 'react';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  None = 'none',
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant | 'primary' | 'secondary' | 'danger' | 'none';
  className?: string;
  loading?: boolean;
}

const baseStyles =
  'inline-flex items-center justify-center px-5 py-2.5 font-medium rounded-md focus:outline-none transition-colors disabled:opacity-50 disabled:cursor-not-allowed ';

const variantStyles: Record<string, string> = {
  none: 'bg-transparent hover:underline shadow-none',
  primary: 'bg-howio-purple  border-howio-purple text-white hover:bg-indigo-700 shadow-sm',
  secondary: 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 shadow-sm',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 shadow-sm',
};

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className = '',
  loading = false,
  disabled,
  ...props
}) => {
  return (
    <button
      className={classNames(baseStyles, variantStyles[variant], className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;
